var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('div',{staticClass:"modal-backdrop",on:{"click":_vm.close}},[_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }